import Web from "./Web";
export default function Investor (){
    return <><Web/></>;
}